import request from '@/utils/request'
import qs from 'qs'

export function getWxSign(query) {
  return request({
    url: '/weixin/sign',
    method: 'get',
    params: query
  })
}

export const putExchangeCode = (data) => {
  return request({
    method: 'post',
    baseURL: '/chaos/api/v1',
    url: '/app/rights/exchange-code',
    data: qs.stringify(data),
    header: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;'
    }
  });
}

export function uploadTrace(data) {
  return request({
    baseURL: process.env.REACT_APP_WOGOO_SERVER,
    url: '/appTraceStat/report',
    method: 'post',
    data: qs.stringify(data),
    header: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;'
    }
  })
}


/**

用户信息
 */
export function getPopmenuInfo( data) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/new/user/vip/popmenu/info`,
    method: 'post',
    data: data
  })
}



export function fetchWeixinCode(query) {
  return request({

    // baseURL: '/server',
    url: `/weixin/sign/v2`,
    method: 'get',
    params: query
  })
}



/**

优惠券活动
 */
export function getCouponActivity( activityId) {
  return request({
    baseURL: '/chaos/api',
    url: `v1/activity/coupon/${activityId}`,
    method: 'post',
    data: {}
  })
}



// WEBPACK FOOTER //
// ./src/api/base.js